import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSuburbanData } from './fetchSuburbanData';
import { IThunkApi } from '../../types/redux';
import { selectEstimationTarget, selectFormFields, selectSource, selectSuburbanFormValues } from '../../selectors';

import { mapEstimationTargetToECategory } from './mappers';
import { IApplicationContext } from '../../types/applicationContext';
import { setErrorMessage, setRedirectUrl } from '../../slices';
import { useGetTrackAddMyHomeObject } from 'shared/mf-my-home/hooks/useGetTrackAddMyHomeObject';

export const submitSuburbanData = createAsyncThunk<void, undefined, IThunkApi>(
  'form/submitSuburbanData',
  async (_, _thunkApi) => {
    const { extra, getState, dispatch } = _thunkApi;

    const state = getState();
    const estimationTarget = selectEstimationTarget(state);
    const filters = selectFormFields(state);

    const { address, landArea, houseArea, isNeedChatSubscribe } = selectSuburbanFormValues(state);
    const source = selectSource(state);

    // oxlint-disable-next-line react/rules-of-hooks
    const trackMyHomeAddObjectSuccess = useGetTrackAddMyHomeObject({ estimationTarget, filters, isSubmit: true });

    const parameters = {
      category: mapEstimationTargetToECategory[estimationTarget],
      address,
      landArea,
      houseArea,
      source,
      isNeedChatSubscribe,
      isNeedPushSubscribe: false,
    };

    try {
      const res = await fetchSuburbanData(parameters, extra as IApplicationContext);

      trackMyHomeAddObjectSuccess();

      dispatch(setRedirectUrl(res));
    } catch (error) {
      dispatch(setErrorMessage(error.message));
    }
  },
);
